module.exports = __webpack_public_path__ + "static/Events-6b7d1d3506f6a42496a1ee82e0145818.png";